import { useQuery } from '@tanstack/react-query';
import type { SetupStatus } from '@pace/contracts';
import { api } from '../lib/api';

export const SETUP_KEY = ['setup-status'] as const;

/** Public: whether the server has a plant yet (first-run wizard) and whether it is a demo. */
export function useSetupStatus() {
  return useQuery({
    queryKey: SETUP_KEY,
    queryFn: () => api<SetupStatus>('/setup/status'),
    staleTime: 5 * 60_000,
    networkMode: 'offlineFirst',
  });
}
